
import { SvgIcon, SvgIconProps } from "@mui/material";
    
export const AppIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
   <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><rect width="7.003" height="11.005" x="15.001" y="9.999" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" rx="1"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15.001 17.002H3.997a2 2 0 0 1-2.001-2V5.997a2 2 0 0 1 2-2.001h14.007a2 2 0 0 1 2 2V10M5.998 20.003H12"/></svg>
  </SvgIcon>
);
